export default {
  data() {
    return {
      
      userType: localStorage.getItem("usrType"),
      userRole: localStorage.getItem("role"),
      
    };
    
  },
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        // text: 'NEW'
      }
    },
    // {
    //   title: true,
    //   name: 'LIVE LIST',
    //   class: '',
    //   wrapper: {
    //     element: '',
    //     attributes: {}
    //   }
    // },
    
    {
      name: 'Admins',
      url: '/Admins',
      icon: 'icon-user'
    },
    {
      name: 'Investigator / Partner',
      url: '/Users',
      icon: 'icon-user'
    },
    // {
    //   name: 'Elephants',
    //   url: '/Elephants',
    //   icon: 'icon-drop'
    // },
    // {
    //   name: 'Divisions',
    //   url: '/Divisions',
    //   icon: 'icon-puzzle'
    // },
    // {
    //   name: 'Ranges',
    //   url: '/Ranges',
    //   icon: 'icon-map'
    // },
    // {
    //   name: 'Forms',
    //   url: '/Forms',
    //   icon: 'icon-pencil'
    // },
    // {
    //   name: 'Form Fields',
    //   url: '/FormFields',
    //   icon: 'icon-eye'
    // },
    {
      name: 'Reports',
      url: '/Reports',
      icon: 'fa fa-file-text-o'
    },

    {
      name: 'Add New Report',
      url: '/AddReport',
      icon: 'icon-note'
    },
    // {
    //   name: 'Sightings',
    //   url: '/Sightings',
    //   icon: 'icon-eye'
    // },
    // {
    //   name: 'Map',
    //   url: '/Map',
    //   icon: 'icon-map'
    // },

    // {
    //   name: 'Buttons',
    //   url: '/buttons',
    //   icon: 'icon-cursor',
    //   children: [
    //     {
    //       name: 'Buttons',
    //       url: '/buttons/standard-buttons',
    //       icon: 'icon-cursor'
    //     },
    //     {
    //       name: 'Button Dropdowns',
    //       url: '/buttons/dropdowns',
    //       icon: 'icon-cursor'
    //     },
    //     {
    //       name: 'Button Groups',
    //       url: '/buttons/button-groups',
    //       icon: 'icon-cursor'
    //     },
    //     {
    //       name: 'Brand Buttons',
    //       url: '/buttons/brand-buttons',
    //       icon: 'icon-cursor'
    //     }
    //   ]
    // },
  ]
}
